// src/components/ChartCard.jsx
import React from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
    Alert,
    AlertTitle,
    Button,
    Stack,
} from '@mui/material';
import * as Lucide from 'lucide-react';
import MultiSeriesChart from './MultiSeriesChart';
import { CODIGO_CONSOLIDANDO } from '../pages/Historico/utils/chartErrors';

function ChartCard({ title, data, error, errorCode, onRetry, sensorType, graficoTipo }) {
    // "Consolidando" nao e falha: o servidor esta preparando os dados deste
    // experimento. Pintar de vermelho faria o laboratorista achar que perdeu o ensaio.
    const consolidando = errorCode === CODIGO_CONSOLIDANDO;
    return (
        <Card
            sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
        >
            <CardHeader
                title={
                    <Typography
                        variant="h6"
                        component="h3"
                        sx={{ fontSize: { xs: '0.95rem', sm: '1.25rem' } }}
                    >
                        {title}
                    </Typography>
                }
                sx={{ pb: 0.5, pt: { xs: 1.5, sm: 2 } }}
            />
            <CardContent
                sx={{
                    // Altura em `dvh` com teto: 400px fixos somados ao cabecalho, as abas
                    // e (nas abas espectrais) mais dois graficos passavam de 900px de
                    // rolagem no celular. Com dvh o grafico se ajusta a tela real, sem
                    // crescer alem do necessario no desktop.
                    height: { xs: 'min(58dvh, 420px)', sm: 480 },
                    minHeight: { xs: 280, sm: 380 },
                    display: 'flex',
                    flexDirection: 'column',
                    px: { xs: 1, sm: 2 },
                    pb: { xs: 1, sm: 2 },
                }}
            >
                {error ? (
                    <Stack
                        sx={{
                            flexGrow: 1,
                            alignItems: 'center',
                            justifyContent: 'center',
                            px: { xs: 0, sm: 1 },
                        }}
                    >
                        <Alert
                            severity={consolidando ? 'info' : 'error'}
                            icon={
                                consolidando ? (
                                    <Lucide.Hourglass size={20} />
                                ) : undefined
                            }
                            sx={{ width: '100%' }}
                            action={
                                onRetry ? (
                                    <Button
                                        color="inherit"
                                        size="small"
                                        onClick={onRetry}
                                        startIcon={<Lucide.RefreshCw size={14} />}
                                    >
                                        Tentar de novo
                                    </Button>
                                ) : undefined
                            }
                        >
                            <AlertTitle sx={{ mb: 0.25 }}>
                                {consolidando
                                    ? 'Gráficos em preparação'
                                    : 'Não foi possível carregar'}
                            </AlertTitle>
                            {error}
                        </Alert>
                    </Stack>
                ) : (
                    <MultiSeriesChart
                        data={data}
                        sensorType={sensorType}
                        graficoTipo={graficoTipo}
                    />
                )}
            </CardContent>
        </Card>
    );
}

export default React.memo(ChartCard);
